import Skeleton from '@mui/material/Skeleton';
import { PageHeader } from 'shared/mui/PageHeader';
import { DatagridSkeleton } from 'shared/react-admin/Datagrids';

import { OrderConversionListSummaryStyled } from './OrderConversionList.styled';
import { OrderConversionListConversionChartSkeleton } from './OrderConversionListConversionChart/OrderConversionListConversionChartSkeleton';
import { OrderConversionListOrdersSkeleton } from './OrderConversionListOrders/OrderConversionListOrdersSkeleton';

export const OrderConversionListSkeleton: React.FC = () => (
  <>
    <OrderConversionListSummaryStyled>
      <OrderConversionListOrdersSkeleton />
      <OrderConversionListConversionChartSkeleton />
    </OrderConversionListSummaryStyled>
    <PageHeader
      headerTitle={{ titleText: <Skeleton variant="text" width={200} />, titleSize: 'medium' }}
      sx={{ marginTop: '21px' }}
    />
    <DatagridSkeleton columnsCount={4} />
  </>
);
